var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclesImageMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 1.719C74.953 1.719 1.5 75.172 1.5 165.78c0 90.609 73.453 164.063 164.062 164.063 90.61 0 164.063-73.454 164.063-164.063S256.172 1.719 165.563 1.719z",
    stroke: "url(#a)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 7.187c-87.59 0-158.594 71.005-158.594 158.594s71.005 158.594 158.593 158.594c87.589 0 158.594-71.005 158.594-158.594S253.151 7.187 165.563 7.187z",
    stroke: "url(#b)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 12.656c-84.57 0-153.125 68.557-153.125 153.125 0 84.569 68.556 153.125 153.124 153.125 84.569 0 153.126-68.556 153.126-153.125 0-84.568-68.557-153.125-153.125-153.125z",
    stroke: "url(#c)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 18.125c-81.549 0-147.657 66.108-147.657 147.656 0 81.549 66.108 147.656 147.656 147.656 81.549 0 147.657-66.107 147.657-147.656 0-81.548-66.108-147.656-147.656-147.656z",
    stroke: "url(#d)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 23.594c-78.528 0-142.188 63.66-142.188 142.187 0 78.528 63.66 142.188 142.187 142.188 78.528 0 142.188-63.66 142.188-142.188 0-78.528-63.659-142.187-142.187-142.187z",
    stroke: "url(#e)",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 29.063c-75.508 0-136.72 61.21-136.72 136.718 0 75.508 61.212 136.719 136.719 136.719 75.508 0 136.719-61.211 136.719-136.719 0-75.507-61.211-136.719-136.718-136.719z",
    stroke: "url(#f)",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 34.531c-72.488 0-131.25 58.763-131.25 131.25 0 72.488 58.762 131.25 131.249 131.25 72.488 0 131.251-58.762 131.251-131.25 0-72.487-58.763-131.25-131.25-131.25z",
    stroke: "url(#g)",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 40C96.096 40 39.781 96.314 39.781 165.781c0 69.467 56.314 125.781 125.781 125.781 69.468 0 125.782-56.314 125.782-125.781C291.344 96.314 235.03 40 165.563 40z",
    stroke: "url(#h)",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 45.469C99.116 45.469 45.25 99.335 45.25 165.78c0 66.447 53.866 120.313 120.312 120.313 66.447 0 120.313-53.866 120.313-120.313S232.009 45.469 165.563 45.469z",
    stroke: "url(#i)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 50.938c-63.427 0-114.844 51.417-114.844 114.843 0 63.427 51.417 114.844 114.843 114.844 63.427 0 114.844-51.417 114.844-114.844 0-63.426-51.417-114.844-114.843-114.844z",
    stroke: "url(#j)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 56.406c-60.407 0-109.375 48.969-109.375 109.375s48.968 109.375 109.374 109.375c60.407 0 109.376-48.969 109.376-109.375S225.969 56.406 165.563 56.406z",
    stroke: "url(#k)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 61.875c-57.386 0-103.907 46.52-103.907 103.906s46.521 103.906 103.906 103.906c57.386 0 103.907-46.52 103.907-103.906S222.948 61.875 165.563 61.875z",
    stroke: "url(#l)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 67.344c-54.366 0-98.438 44.072-98.438 98.437 0 54.366 44.072 98.438 98.437 98.438 54.366 0 98.438-44.072 98.438-98.438 0-54.365-44.072-98.437-98.437-98.437z",
    stroke: "url(#m)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 72.813c-51.346 0-92.97 41.623-92.97 92.968 0 51.345 41.624 92.969 92.969 92.969 51.346 0 92.969-41.624 92.969-92.969 0-51.345-41.623-92.969-92.968-92.969z",
    stroke: "url(#n)",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 78.281c-48.325 0-87.5 39.175-87.5 87.5s39.175 87.5 87.499 87.5c48.325 0 87.501-39.175 87.501-87.5s-39.176-87.5-87.5-87.5z",
    stroke: "url(#o)",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 83.75c-45.305 0-82.032 36.727-82.032 82.031 0 45.305 36.727 82.031 82.031 82.031 45.305 0 82.032-36.726 82.032-82.031 0-45.304-36.727-82.031-82.031-82.031z",
    stroke: "url(#p)",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 89.219C123.278 89.219 89 123.497 89 165.78c0 42.285 34.278 76.563 76.562 76.563 42.285 0 76.563-34.278 76.563-76.563 0-42.284-34.278-76.562-76.562-76.562z",
    stroke: "url(#q)",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 94.688c-39.264 0-71.094 31.829-71.094 71.093s31.83 71.094 71.093 71.094c39.264 0 71.094-31.83 71.094-71.094 0-39.264-31.829-71.094-71.093-71.094z",
    stroke: "url(#r)",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 100.156c-36.244 0-65.625 29.382-65.625 65.625 0 36.244 29.381 65.625 65.624 65.625 36.244 0 65.626-29.381 65.626-65.625 0-36.243-29.382-65.625-65.625-65.625z",
    stroke: "url(#s)",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 105.625c-33.224 0-60.157 26.933-60.157 60.156 0 33.224 26.933 60.156 60.156 60.156 33.224 0 60.157-26.932 60.157-60.156 0-33.223-26.933-60.156-60.156-60.156z",
    stroke: "url(#t)",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 111.094c-30.204 0-54.688 24.484-54.688 54.687 0 30.203 24.484 54.688 54.687 54.688 30.204 0 54.688-24.485 54.688-54.688 0-30.203-24.484-54.687-54.687-54.687z",
    stroke: "url(#u)",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 116.562c-27.183 0-49.219 22.036-49.219 49.219S138.38 215 165.562 215c27.183 0 49.219-22.036 49.219-49.219s-22.036-49.219-49.218-49.219z",
    stroke: "url(#v)",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 122.031c-24.163 0-43.75 19.588-43.75 43.75 0 24.163 19.587 43.75 43.749 43.75 24.163 0 43.751-19.587 43.751-43.75 0-24.162-19.588-43.75-43.75-43.75z",
    stroke: "url(#w)",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 127.5c-21.143 0-38.282 17.139-38.282 38.281s17.139 38.281 38.281 38.281c21.143 0 38.282-17.139 38.282-38.281S186.705 127.5 165.563 127.5z",
    stroke: "url(#x)",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 132.969c-18.122 0-32.813 14.69-32.813 32.812s14.691 32.813 32.812 32.813c18.122 0 32.813-14.691 32.813-32.813s-14.691-32.812-32.812-32.812z",
    stroke: "url(#y)",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 138.437c-15.102 0-27.344 12.243-27.344 27.344 0 15.102 12.242 27.344 27.343 27.344 15.102 0 27.344-12.242 27.344-27.344 0-15.101-12.242-27.344-27.343-27.344z",
    stroke: "url(#z)",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 143.906c-12.082 0-21.875 9.794-21.875 21.875s9.793 21.875 21.874 21.875c12.082 0 21.876-9.794 21.876-21.875s-9.794-21.875-21.875-21.875z",
    stroke: "url(#A)",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 149.375c-9.061 0-16.407 7.345-16.407 16.406s7.346 16.406 16.406 16.406c9.061 0 16.407-7.345 16.407-16.406s-7.346-16.406-16.406-16.406z",
    stroke: "url(#B)",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 154.844c-6.041 0-10.938 4.897-10.938 10.937 0 6.041 4.897 10.938 10.937 10.938 6.041 0 10.938-4.897 10.938-10.938 0-6.04-4.897-10.937-10.937-10.937z",
    stroke: "url(#C)",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 160.312a5.469 5.469 0 1 0 0 10.938 5.469 5.469 0 0 0 0-10.938z",
    stroke: "url(#D)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 247.813,
    y1: 166.438,
    x2: 83.75,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 329.844,
    y1: 166.438,
    x2: 1.719,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 318.906,
    y1: 166.437,
    x2: 12.656,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 313.438,
    y1: 166.438,
    x2: 18.125,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 307.969,
    y1: 166.438,
    x2: 23.594,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 302.5,
    y1: 166.438,
    x2: 29.063,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 297.031,
    y1: 166.438,
    x2: 34.531,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 291.563,
    y1: 166.438,
    x2: 40,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 286.094,
    y1: 166.438,
    x2: 45.469,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 280.625,
    y1: 166.438,
    x2: 50.938,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 275.156,
    y1: 166.438,
    x2: 56.406,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 269.688,
    y1: 166.438,
    x2: 61.875,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 264.219,
    y1: 166.438,
    x2: 67.344,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 258.75,
    y1: 166.438,
    x2: 72.813,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 253.281,
    y1: 166.438,
    x2: 78.281,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 324.375,
    y1: 166.438,
    x2: 7.188,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 242.344,
    y1: 166.437,
    x2: 89.219,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 236.875,
    y1: 166.438,
    x2: 94.688,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 231.406,
    y1: 166.438,
    x2: 100.156,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 225.938,
    y1: 166.438,
    x2: 105.625,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 220.469,
    y1: 166.438,
    x2: 111.094,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 215,
    y1: 166.438,
    x2: 116.563,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 209.531,
    y1: 166.438,
    x2: 122.031,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 204.063,
    y1: 166.437,
    x2: 127.5,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 198.594,
    y1: 166.438,
    x2: 132.969,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 193.125,
    y1: 166.438,
    x2: 138.438,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 187.656,
    y1: 166.438,
    x2: 143.906,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 182.188,
    y1: 166.438,
    x2: 149.375,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 176.719,
    y1: 166.438,
    x2: 154.844,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 171.25,
    y1: 166.438,
    x2: 160.313,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F7941D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesImageMin);
export default __webpack_public_path__ + "static/media/Circles Image-min.41b8cc4e83e4db7958eb1f24ede2ce75.svg";
export { ForwardRef as ReactComponent };